module.exports = __webpack_public_path__ + "static/img/news4detail4.fc469df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4detail4.jpg
// module id = K0Do
// module chunks = 0